import { cloneDeep } from "lodash";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { dispatch } from "store/store";
import { proposals as constants } from "store/constants";
import {
	parseJSON,
	getKeysFromColumnHeaders,
	findProposals as queryProposals,
	notifyError,
} from "utils";
import { actionFactory as feedActionFactory } from "store/factories/feed";
import { actionLoaderFactory } from "store/factories/fetchable";
import { updateProposalAdminTeamMembers } from "store/actions/proposal";
import { IS_DEV, PROPOSAL_SUMMARY_ITEMS } from "globals/constants";
import Pager from "components/Pager";
import { countNumberSummaryItems } from "utils/summary";
import { mutateAdminTeamMembers } from "utils/teamMembers";
import { columnsSelectors, proposalListSelectors } from "../selectors";
import { api } from "services";


export const { setPaging } = feedActionFactory(constants);

const listFactory = actionLoaderFactory(constants, constants.PROPOSAL_LIST);
const summaryFactory = actionLoaderFactory(constants, constants.PROPOSAL_SUMMARY);

export const findProposals = async ({ pageLimit, pageOffset, searchTerms, fieldKeys, isRefresh = false }) => {
	return listFactory.createLoaderAction(
		() => queryProposals({ pageLimit, pageOffset, searchTerms, fieldKeys }),
		[
			(response) => {
				listFactory.setData(response);

				return response;
			},
			(error, { getState }) => {
				const dictionary = getState().dictionary.proposals;
				const message = IS_DEV ? error.message : dictionary.errors.ProposalsFailedLoad;

				notifyError(message, error)
				listFactory.setError(message);
			},
		],
		{ isRefresh },
	);
};

export const getProposalSummary = async () => {
	return summaryFactory.createLoaderAction(
		api.proposal.getSummary,
		[
			(response) => {
				summaryFactory.setData(countNumberSummaryItems(PROPOSAL_SUMMARY_ITEMS, response));
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.proposals.errors.tilesFailedLoad;

				notifyError(message, error)
				summaryFactory.setError(message);
			},
		],
	);
};

export const setProposalSearchBar = search => {
	dispatch({ type: constants.SET_SEARCH, search: isNonEmptyString(search) ? parseJSON(search) : search });
};

export const refreshProposals = async () => {
	const {
		search: searchTerms,
		paging: {
			pageNumber,
			pageLimit,
		},
	} = proposalListSelectors.content();
	const { activeColumns } = columnsSelectors.proposals();

	const pageOffset = Pager.pageOffsetByPageNumber(pageNumber);
	const fieldKeys = getKeysFromColumnHeaders(activeColumns);

	getProposalSummary();
	findProposals({ pageLimit, pageOffset, searchTerms, fieldKeys, isRefresh: true });
};

export const updateAdminTeamMembersPerProposal = idAdminTeamMemberArray => {
	const items = cloneDeep(proposalListSelectors.content().items);

	mutateAdminTeamMembers(idAdminTeamMemberArray, items);

	listFactory.setData({ items });

	updateProposalAdminTeamMembers(idAdminTeamMemberArray);
};
